<script setup lang="ts">
import type {DebtorContactResponse} from "../../../responses/Site/DebtorContactResponse";
import StarRating from 'vue-star-rating'
import {ref, type Ref} from "vue";
import {onMounted} from "vue";
import Errors from "../Errors.vue";
import {label} from "../../mixins/translations";
import {setRecaptchaKey} from "../../scripts/recapcha";
import {api} from "../../scripts/api";
import Error from "../Error.vue";
import {get} from 'lodash';

interface Props{
    user?: DebtorContactResponse
    recaptchaKey: String
    productId: Number
}

const props = defineProps<Props>();
const lang = window.language;
const form: Ref<Object> = ref({
    email: props.user?.email ?? '',
    name: props.user?.full_name ?? '',
    stars: 5,
    title: {
        [lang]: null,
    },
    content: {
        [lang]: null,
    },
    recaptcha: '',
    product_id: props.productId,
});

const message: Ref<string> = ref('');
const errors: Ref<Object> = ref({}); //TODO errorbagresponse
const submitted: Ref<boolean> = ref(false);
const loading: Ref<boolean> = ref(false);
const successMessage: Ref<String> = ref('');

const handleForm = () => {
    loading.value = true;

    grecaptcha.ready(function() {
        grecaptcha.execute(props.recaptchaKey, {action: 'reviewform'}).then(function(token) {
            form.value.recaptcha = token;

            api().post(
                `/site/form/review/`,
                form.value,
            ).then(response => {
                successMessage.value = response.data.message;
                submitted.value = true;
            }).catch(error => {
                errors.value = error.response.data.errors ?? {};
            });
        });
    });
}

onMounted(() => {
    if (props.debtorContact) {
        form.value.email = props.debtorContact.email;
        form.value.name = props.debtorContact.full_name;
    }
    setRecaptchaKey(props.recaptchaKey);
});
</script>
<template>
    <div class="w-full p-4 bg-gray-100 mt-2">
        <div class="w-full bg-secondary-500 text-white p-4" v-if="submitted" v-text="successMessage">
        </div>
        <div class="w-full" v-else>
            <div class="w-full">
                <div v-if="errors?.recaptcha" class="text-error-500" v-text="errors.recaptcha">
                </div>
                <label class="text-sm text-gray-600">
                    {{ label('site.review.stars') }}
                    <span class="text-error-500">*</span>
                </label>
                <star-rating
                    v-model="form.stars"
                    :increment="0.5"
                    :rating="5"
                    :read-only="false"
                    :show-rating="false"
                    :star-size="25"
                ></star-rating>
            </div>
            <div class="mt-2 space-y-1">
                <label class="text-sm text-gray-600">
                    {{ label('site.review.name') }}
                    <span class="text-error-500">*</span>
                </label>
                <input
                    class="appearance-none border border-secondary-300 p-2 rounded-md shadow-xs checked:bg-secondary-500 checked:text-secondary-500 disabled:bg-secondary-100 disabled:opacity-50 disabled:cursor-not-allowed focus:border-secondary-950 focus:ring-secondary-950 block w-full sm:text-sm"
                    type="text" id="name" name="name" v-model="form.name">
                <Errors :errors="errors?.name"/>
            </div>
            <div class="mt-2 space-y-1">
                <label class="text-sm text-gray-600">
                    {{ label('site.review.email') }}
                    <span class="text-error-500">*</span>
                </label>
                <input
                    class="appearance-none border border-secondary-300 p-2 rounded-md shadow-xs checked:bg-secondary-500 checked:text-secondary-500 disabled:bg-secondary-100 disabled:opacity-50 disabled:cursor-not-allowed focus:border-secondary-950 focus:ring-secondary-950 block w-full sm:text-sm"
                    type="text" id="name" name="name" v-model="form.email">
                <Errors :errors="errors?.email"/>
            </div>
            <div class="mt-2 space-y-1">
                <label class="text-sm text-gray-600">
                    {{ label('site.review.title') }}
                </label>
                <input
                    class="appearance-none border border-secondary-300 p-2 rounded-md shadow-xs checked:bg-secondary-500 checked:text-secondary-500 disabled:bg-secondary-100 disabled:opacity-50 disabled:cursor-not-allowed focus:border-secondary-950 focus:ring-secondary-950 block w-full sm:text-sm"
                    type="text" id="title" name="title" v-model="form.title[lang]">
                <Errors :errors="errors['title.'.lang]"/>
            </div>
            <div class="mt-2 space-y-1">
                <label class="text-sm text-gray-600">
                    {{ label('site.review.content') }}
                    <span class="text-error-500">*</span>
                </label>
                <textarea
                    class="appearance-none border border-secondary-300 p-2 rounded-md shadow-xs checked:bg-secondary-500 checked:text-secondary-500 disabled:bg-secondary-100 disabled:opacity-50 disabled:cursor-not-allowed focus:border-secondary-950 focus:ring-secondary-950 block w-full sm:text-sm"
                    type="text" id="name" name="name" v-model="form.content[lang]"></textarea>
                <Error v-if="errors.hasOwnProperty('content.' + lang)" :error="get(errors, 'content.' + lang)[0]" />
            </div>
            <div class="mt-2 justify-end items-end flex">
                <a class="w-auto py-2 px-4 bg-green-500 hover:bg-green-600 text-white text-sm font-medium text-center cursor-pointer" @click.prevent="handleForm">
                    {{ label('site.button.save') }}
                </a>
            </div>
        </div>
    </div>
</template>
